import { MobileOrderNotificationComponent } from './../mobile-order-notification/mobile-order-notification.component';
import { ToastrService } from "ngx-toastr";

import { OrderNotificationParams, OrderNotificationComponent } from "./order-notification.component";

import { isDevMode } from "@angular/core";

export function ShowOrderNotification(toastr: ToastrService, params: OrderNotificationParams, mobileMode: string = 'desktop')
{
    const mobile = mobileMode != 'desktop';
    let config = Object.assign(toastr.toastrConfig, {});
    config.timeOut = 6000;
    config.progressBar = true;
    config.closeButton = true;
    config.toastComponent = mobile? MobileOrderNotificationComponent: OrderNotificationComponent;
    if(params.responseData.Type=="OrderRs")
    {
        if(params.responseData.LimitPrice>0||params.responseData.StopPrice>0)
        {
            params.responseData.Type = "Pending";
        }
        
    }
    return toastr.show(JSON.stringify(params), '', config);
}